export default "__VITE_ASSET__u5Q1SLph__"